import { action, computed, observable } from 'mobx'
import React from 'react'

export interface IPatientIdStore {
  patientId: number
  getId: number
  setPatientId(patientId: number): void
}

export class PatientIdStore implements IPatientIdStore{
  @observable
  public patientId: number

  @computed
  public get getId(): number {
    return this.patientId
  }

  @action.bound
  public setPatientId(patientId: number): void {
    this.patientId = patientId
  }
}



// WEBPACK FOOTER //
// ./src/stores/PatientIdStore.tsx